<template>
          <div  class="cusmenu">
                        <div class="m_item " :class="{'active':currentChange==1}" @click="eventChange('doChannelAll')">全渠道</div>
                        <div class="m_line"></div>
                        <div class="m_item"  :class="{'active':currentChange==2}" style="flex:2" @click="eventChange('doChannel')">
                            <div style="width: 70px; text-align: center;">城市</div>
                            <div style="flex: 1; display: flex; align-items: center;justify-content: space-between;">
                                  <span>< </span>
                                广州
                                <span>></span>
                            </div>
                            <div class="m_k"></div>
                        </div>
                        <div class="m_line"></div>
                        <div class="m_item"  :class="{'active':currentDate==1}" @click="eventChange('doYear')">本年度</div>
                          <div class="m_k"></div>
                        <div class="m_item "  :class="{'active':currentDate==2}" @click="eventChange('doMouth')">本月</div>
                          <div class="m_k"></div>
                        <div class="m_item"  :class="{'active':currentDate==3}"  @click="eventChange('doDate')">今日</div>
                    </div>
</template>
<script>
export default {
  name: 'cusmenu',
  props: {  
    
  },
  data () {  
    return {     
       currentDate:1,
       currentChange:1,
       mvalue:{}    
    }
  },
  methods: {
    outValue(other){
       const {currentDate,currentChange,mvalue}=this;
       mvalue.currentChange=currentChange;
       mvalue.currentDate=currentDate;
       other&&(mvalue[other.key]=other.value);
    },
    doChannel(){
      this.currentChange=2;   
    },
    doChannelAll(){
      this.currentChange=1;   
    },
     doMouth(){
       this.currentDate=2;
        return {mouth:2}
    
     },
     doDate(){
       this.currentDate=3;
       return {date:3}
     },
     doYear(){
       this.currentDate=1;
       return {year:1}
     },
     eventChange(name){   
       this.outValue(this[name]&&this[name]())
       this.$emit("echange",this.mvalue)
     }    
  },
  mounted () {
  
  },
  
}
</script>

<style lang="scss">
   .cusmenu{
        display:flex; 
        height: 100%;
        align-items: center;
  .m_item{
       flex: 1;
       border-radius: 3px;
       height: 100%;
       background: #070918;
       border: 1px solid #8789FF;
            font-size: 15px;
        color: #8789FF;
        letter-spacing: 0;
        text-align: center;
            display: flex;
    align-items: center;
    justify-content: center;
   }
   .m_item.active{
        background: #4346D3;
        border: 1px solid #4346D3;
        color:#fff
   }
   .m_line{
      border-left:1px solid #46488B;
      height: 12px;
      margin: 0px 10px;
   }
   .m_k{
        margin: 0px 5px;
   }
    }
 
</style>